import {SHIELD_CONTRACT} from "../../constants/contracts";

export const web3CalculateBNBReward = async (address: string, chainId: number, web3: any) => {
    const shieldContract = SHIELD_CONTRACT[chainId];
    const contract = new web3.eth.Contract(shieldContract.abi, shieldContract.address);
    const balance = await contract.methods.calculateBNBReward(address).call();
    return web3.utils.toBN(balance);
}
